/**
 * Lazily creates an AudioContext on first call. Resumes it on every subsequent user gesture in
 * case browsers auto-suspended it.
 */
export class AudioContextManager {
  private ctx: AudioContext | null = null;

  ensure(): AudioContext {
    if (this.ctx === null) {
      this.ctx = new AudioContext();
    }
    if (this.ctx.state === "suspended") {
      void this.ctx.resume();
    }
    return this.ctx;
  }

  context(): AudioContext | null {
    return this.ctx;
  }
}
